@if (showAccounting$ | async) {
  <ng-content></ng-content>
} @else {
  <section class="relative w-full h-full md:pt-16 md:pl-16">
    <div class="md:p-12 p-4 max-w-4xl border rounded bg-white relative z-10 box-shadow">
      <div class="flex flex-col-reverse md:flex-row items-start gap-6">
        <div class="flex-shrink-1 flex flex-col gap-4 min-w-[210px]">
          <img
            src="/assets/images/apps/qb-business-affiliate.svg"
            alt="QuickBooks Business Affiliate"
            class="max-w-[300px]" />
          <sbnb-alert-card context="neutral" class="flex flex-col gap-2 justify-center">
            <strong>Don't have QuickBooks yet?</strong>
            <div>Sign up for QuickBooks and save 30% on QuickBooks for 6 months!</div>
            <sbnb-button type="secondary" size="mini">
              <a href="https://quickbooks.partnerlinks.io/8slmaqe5fsju" target="_blank">Sign up for QuickBooks</a>
            </sbnb-button>
          </sbnb-alert-card>
        </div>

        <div>
          <h1>Accounting shouldn't be so hard, so we make it simple.</h1>

          <p>
            Connect your QuickBooks Online account to automatically categorize reservation income into granular accounts
            — ensuring accurate, hassle-free financial reporting, automated each time you publish an Owner's Statement
            or Invoice in Hospitable.
          </p>

          <p>Accounting integrations are included on our Mogul plan.</p>

          <p>
            Schedule a call with our team to learn more about Accounting and our Mogul plan, or upgrade to Mogul today
            to get started.
          </p>

          <div class="flex items-center gap-4">
            <sbnb-button label="Schedule a call!" (clicked)="scheduleCall()"></sbnb-button>
            <sbnb-button
              *ngIf="showMogulUpgrade$ | async"
              type="secondary"
              label="Upgrade"
              (clicked)="upgradeToMogul()"></sbnb-button>
            <sbnb-button type="text" size="mini">
              <a href="https://hospitable.storylane.io/share/4bskqmmemzif" target="_blank">
                Explore the QuickBooks integration
              </a>
            </sbnb-button>
          </div>
        </div>
      </div>
    </div>
  </section>
}
